import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';
import { userHasFeature } from '../../../helpers/Features';

const AdminCustomFieldEditHeader = ({ customFieldId }) => {
  const intl = useIntl();
  const history = useHistory();

  return (
    <header className="page-header">
      <h3 className="page-title">
        {customFieldId ? intl.formatMessage({ defaultMessage: 'Edit Custom Field' }) :
          intl.formatMessage({ defaultMessage: 'New Custom Field' })}
      </h3>
      <div className="header-actions users-actions">
        <div className="button-wrapper">
          {customFieldId && (
            <Button
              color="primary"
              onClick={() => { history.push({ pathname: '/admin/settings/custom-fields/add' }); }}
              disabled={!userHasFeature('custom-fields')}
            >
              <i className="fas fa-plus" />
              {intl.formatMessage({ defaultMessage: 'Custom Field' })}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

AdminCustomFieldEditHeader.propTypes = {
  customFieldId: PropTypes.string,
};

AdminCustomFieldEditHeader.defaultProps = {
  customFieldId: null,
};

export default AdminCustomFieldEditHeader;
